import base from './base'
import axios from '../axios/request'
import request from "@/utils/request";

const http = {
    // testGet:function(params){
    //     return axios.get(base.test,{params})
    // },
    // testPost:function(params){
    //     return axios.post(base.test,params)
    // }
}
export default http

export function uploadImg(file) {
    const formData = new FormData();
    formData.append('file', file);

    return request({
        url: '/dev-api/upload/registerImage',
        method: 'post',
        data: formData,
        headers: {
            'Content-Type': 'multipart/form-data',
            isToken: false
        }
    });
}

export function commissionAdd(data) {
    return request({
        url: '/dev-api/commission/add',
        method: 'post',
        data: data
    })
}

/**
 * 委托列表
 * @param data
 * @returns {*}
 */

export function commissionList(data) {
    return request({
        url: '/dev-api/commission/list',
        method: 'get',
        params: data
    })
}

/**
 * 根据id查看存证详情
 */
export function evidenceById(id) {
    return request({
        url: '/dev-api/evidence/id?id=' + id,
        method: 'get'
    })
}

/**
 *
 */
export function queryUser(params) {
    return request({
        url: '/dev-api//newLogin/queryUser',
        method: 'get',
        params: params
    })
}

/** 会员账号启用/禁用：status 0正常 1停用 */
export function updateUserStatus(data) {
    return request({
        url: '/dev-api/newLogin/updateUserStatus',
        method: 'put',
        data: data
    })
}

/**
 * 知企通接口
 */
export function knowledge(companyName) {
    return request({
        url: '/dev-api/knowledge/knowledge?companyName=' + companyName,
        method: 'get',
        timeout: 250000,
    })
}


export function getApi(companyName) {
    return request({
        url: 'https://aip.baidubce.com/rpc/2.0/ai_custom/v1/wenxinworkshop/chat/ernie-3.5-128k?access_token=24.961dd6a13f4860a46998d7e7d8a4dc83.2592000.1738812892.282335-116594814',
        method: 'POST',
        data: companyName,
        timeout: 250000,
    })
}


export function getToken() {
    return request({
        url: '/dev-api/knowledge/getToken',
        method: 'get',
    })


}

//删除存证
export function deleteEvidence(id) {
    return request({
        url: '/dev-api/evidence/' + id,
        method: 'delete',
    })
}

export function achievementTransfersListNotAdmin(data) {
    return request({
        url: '/dev-api/evidence/achievementTransfersListNotAdmin',
        method: "GET",
        params: data,
    })
}

export function updateUserPhone(data) {
    return request({
        url: '/dev-api/SysUserNew/updateUserPhone',
        method: "PUT",
        data: data,
    })
}

export function derivativeDiagram(data) {
    return request({
        url: '/dev-api/knowledge/derivativeDiagram?industry=' + data,
        method: "GET",
        timeout: 2500000,
    })
}

export function derivativeDiagramDown(data) {
    return request({
        url: '/dev-api/knowledge/derivativeDiagramDown?industry=' + data,
        method: "GET",
        timeout: 2500000,
    })
}


/**
 * 暂存
 * @param data
 * @returns {*}
 */
export function temporarily(data) {
    return request({
        url: '/dev-api/temporarily',
        headers: {
            isToken: false
        },
        method: 'post',
        data: data
    })
}

/**
 * 获取暂存列表
 * @param data
 * @returns {*}
 */
export function temporarilyList(data) {
    return request({
        url: '/dev-api/temporarily/list',
        headers: {
            isToken: false
        },
        method: 'get',
        params: data
    })
}

/**
 * 根据id获取暂存记录
 * @param id
 * @returns {*}
 */
export function temporarilyById(id) {
    return request({
        url: '/dev-api/temporarily/' + id,
        headers: {
            isToken: false
        },
        method: 'get'
    })
}

/**
 * 修改存证数据
 * @param data
 * @returns {*}
 */

export function updateTemporarily(data) {
    return request({
        url: '/dev-api/temporarily',
        headers: {
            isToken: false
        },
        method: 'put',
        data: data
    })
}

/**
 * 删除暂存记录
 * @returns {*}
 * @param id
 */

export function deleteTemporarily(id) {
    return request({
        url: '/dev-api/temporarily/' + id,
        headers: {
            isToken: false
        },
        method: 'DELETE',
    })
}

/**
 * 暂存存证
 */
export function temporaryCertificates(data) {
    return request({
        url: '/dev-api/evidence/temporaryCertificates',
        headers: {
            isToken: false
        },
        method: 'Post',
        data: data
    })
}

/**
 * 修改提交成果
 */

export function changeEvidence(data) {
    return request({
        url: '/dev-api/evidence/change',
        headers: {
            isToken: true
        },
        method: 'Put',
        data: data
    })
}

export function downloadTemplate() {
    return request({
        url: '/dev-api//evidence/download/excel',
        headers: {
            isToken: true
        },
        method: 'get',
        responseType: 'blob' // ⚠️ 必须加这一行！
    })
}


/**
 * 百度文心一言接口
 * @returns {*}
 */
export function artificialIntelligence(text) {
    return request({
        url: '/dev-api/wenXinApi/artificialIntelligence?context=' + text,
        headers: {
            isToken: true
        },
        method: 'get',
        timeout: 2500000,
    })
}


/**
 * 获取单位
 */
export function getUnit(param) {
    return request({
        url: "/dev-api/obtainClassification/unit",
        method: 'get',
        params: param
    })
}

export function registration(data) {
    return request({
        url: "/dev-api/obtainClassification/registration",
        method: 'POST',
        data: data
    })
}

export function unitByManagement(param) {
    return request({
        url: "/dev-api/obtainClassification/unitByManagement",
        method: 'GET',
        params: param
    })
}

export function unitChange(data) {
    return request({
        url: "/dev-api/evidence/unitChange",
        method: 'put',
        data: data
    })
}

export function visit(data) {
    return request({
        url: '/dev-api/system/statistics/visit',
        method: 'POST',
        data: data
    })
}

export function tableAdd(data) {
    return request({
        url: '/dev-api/system/table/add',
        method: 'POST',
        data: data
    })
}
